// src/features/theme/themeSlice.ts
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {THEME_MODES, ThemeMode} from './THEME_MODES';

export interface ThemeState {
    value: ThemeMode;
}

const initialState = {
    value: (localStorage.getItem('theme') as ThemeMode) || THEME_MODES.LIGHT,
};

export const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setTheme: (state, action: PayloadAction<ThemeMode>) => {
            state.value = action.payload;
            localStorage.setItem('theme', action.payload); // 🔐 persisté ici
        },
        toggleTheme: (state) => {
            state.value = state.value === THEME_MODES.DARK ? THEME_MODES.LIGHT : THEME_MODES.DARK;
        },
    },
});

export const {setTheme, toggleTheme} = themeSlice.actions;
export default themeSlice.reducer;
